import { render, staticRenderFns } from "./our-programs.component.vue?vue&type=template&id=d4cd15e2&"
import script from "./our-programs.component.ts?vue&type=script&lang=ts&"
export * from "./our-programs.component.ts?vue&type=script&lang=ts&"
import style0 from "./our-programs.component.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports